import template from './financeProperty.html';

export const financePropertyComponent = {
  restrict: 'E',
  template,
  controllerAs: 'vm',
  bindings: {
    property: '<',
    value: '<',
    item: '<'
  }
};
